import { render, staticRenderFns } from "./Produkt.vue?vue&type=template&id=54753c38&"
import script from "./Produkt.vue?vue&type=script&lang=ts&"
export * from "./Produkt.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports